import { CommonAPI } from "../Client";

const getWebsiteProductFeaturePayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { websiteId, ...featurePayload } = payload;
  return featurePayload;
};

const getOrderProcessChildPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { websiteProductFeatureId, ...orderProcessChildPayload } = payload;
  return orderProcessChildPayload;
};

const getProductFeatureChildPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { websiteId, ...productFeatureChildPayload } = payload;
  return productFeatureChildPayload;
};

export const getWebsiteProductFeatureApi = async (payload = {}) => {
  try {
    const websiteId = payload?.websiteId ?? payload;
    const response = await CommonAPI.get(
      `/website/product/feature?websiteId=${websiteId || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getProductFeatureChildApi = async (payload = {}) => {
  try {
    const queryParams = new URLSearchParams();

    if (payload && typeof payload === "object") {
      if (payload?.id) queryParams.set("id", payload.id);
      if (payload?.websiteId) queryParams.set("websiteId", payload.websiteId);
      if (payload?.productFeatureType) {
        queryParams.set("productFeatureType", payload.productFeatureType);
      }
    } else if (payload) {
      queryParams.set("id", payload);
    }

    const response = await CommonAPI.get(
      `/product/feature/child${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postProductFeatureChildApi = async (payload = {}) => {
  try {
    const response = await CommonAPI.post(
      `/product/feature/child?websiteId=${payload?.websiteId || ""}`,
      getProductFeatureChildPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateProductFeatureChildApi = async (payload = {}) => {
  try {
    const response = await CommonAPI.put(
      "/product/feature/child",
      payload?.dto || payload,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteProductFeatureChildApi = async (payload = {}) => {
  try {
    const childId = payload?.childId ?? payload?.id ?? payload;
    const response = await CommonAPI.delete(
      `/product/feature/child/${childId || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getWebsiteProductFeatureOrderProcessChildApi = async (
  payload = {},
) => {
  try {
    const id = payload?.id ?? payload;
    const response = await CommonAPI.get(
      `/website/product/feature/order/process/child?id=${id || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getOrderProcessChildByWebsiteProductFeatureApi = async (
  payload = {},
) => {
  try {
    const websiteProductFeatureId = payload?.websiteProductFeatureId ?? payload;
    const response = await CommonAPI.get(
      `/order/process/child/${websiteProductFeatureId || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postWebsiteProductFeatureOrderProcessChildApi = async (
  payload = {},
) => {
  try {
    const response = await CommonAPI.post(
      `/website/product/feature/order/process/child?websiteProductFeatureId=${
        payload?.websiteProductFeatureId || ""
      }`,
      getOrderProcessChildPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateWebsiteProductFeatureOrderProcessChildApi = async (
  payload = {},
) => {
  try {
    const response = await CommonAPI.put(
      "/website/product/feature/order/process/child",
      getOrderProcessChildPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteWebsiteProductFeatureOrderProcessChildApi = async (
  payload = {},
) => {
  try {
    const id = payload?.id ?? payload;
    const response = await CommonAPI.delete(
      `/website/product/feature/order/process/child?id=${id || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postWebsiteProductFeatureApi = async (payload = {}) => {
  try {
    const response = await CommonAPI.post(
      `/website/product/feature?websiteId=${payload?.websiteId || ""}`,
      getWebsiteProductFeaturePayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateWebsiteProductFeatureApi = async (payload = {}) => {
  try {
    const response = await CommonAPI.put(
      `/website/product/feature?websiteId=${payload?.websiteId || ""}`,
      getWebsiteProductFeaturePayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteWebsiteProductFeatureApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await CommonAPI.delete(
      `/website/product/feature?id=${id || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
